// extracted by mini-css-extract-plugin
module.exports = {"links":"patient-page-alert-module__links___1vhn-","alertButton":"patient-page-alert-module__alertButton___2H5bO"};